import { Routes } from '@angular/router';
import { OrganizationList } from './components/organization-list/organization-list';
import { OrganizationMap } from './components/organization-map/organization-map';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'organization-map',
    pathMatch: 'full',
  },
  {
    path: 'organization-map',
    component: OrganizationMap,
  },
  // Organization
  {
    path: 'organization-list',
    component: OrganizationList,
  },
  {
    path: 'organization/:slug',
    loadComponent: () => import('./components/organization-view/organization-view').then(m => m.OrganizationView),
  },
  // Claim ownership / register organization
  {
    path: 'claim-ownership',
    loadComponent: () => import('./components/claim-ownership/claim-ownership').then(m => m.ClaimOwnership),
  },
  {
    path: 'claim-ownership/:slug',
    loadComponent: () => import('./components/claim-ownership/claim-ownership').then(m => m.ClaimOwnership),
  },
  // Unknown URL: send the user back to the map
  {
    path: '**',
    redirectTo: 'organization-map',
  },
];
